<!-- <div [ngClass]="{'selected':application?.id === selectedApp?.id || router.url.includes(application?.id) }" class="application card card-widget widget-user"
 [routerLink]="router.url.includes('/root/applications') ? [application?.id] : []" [queryParams]="urlParams">

  <div [ngClass]="{'card-dark': router.url.includes('/customer/users')}">
    <div style="position: absolute; right: 0;"
      class="edit-container">
      <div class="dropdown">
        <button class="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false">
          <i class="fa fa-ellipsis-v"></i>
        </button>

        <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
          <ng-container *ngIf="!router.url.includes('/root/applications')">
            <a class="dropdown-item" style="cursor: pointer;" (click)="onEditClient(application)"
              translate>global.edit</a>
            <a *ngIf="currentUser.role.name === 'root'" class="dropdown-item" style="cursor: pointer;"
             (click)="onInvoiceConfig(application)" translate>Invoice Config</a>
            <a *ngIf="currentUser.role.name === 'root'" class="dropdown-item" style="cursor: pointer;"
              (click)="onSSHSetup(application)" translate>SSH Key Setup</a>
          </ng-container>
          <a *ngIf="['root', 'customer'].includes(currentUser.role.name)" class="dropdown-item" style="cursor: pointer;"
            (click)="onChangeCustomer(application)" translate>Change Customer</a>
        </div>
      </div>
    </div>
    <div class="widget-user-header" (click)="showUsers(application)">
      <a class="widget-user-username">{{application?.name}}</a>
      <hr>
      <h6 class="widget-user-desc"><strong translate>customer.description</strong> {{application?.description}}</h6>
      <h6 *ngIf="router.url.includes('/root/applications')" class="widget-user-desc"><strong>Belongs to:</strong>
        {{customer}}
      </h6>
      <h6 class="widget-user-desc"><strong translate>customer.country</strong> {{application?.country ?
        application.country
        : '/'}}</h6>
      <h6 class="widget-user-desc"><strong translate>customer.city</strong> {{application?.city ? application.city
        : '/'}}
      </h6>
      <h6 class="widget-user-desc"><strong translate>customer.address</strong> {{application?.address ? application.address
        : '/'}}</h6>
      <h6 class="widget-user-desc"><strong translate>customer.postCode</strong> {{application?.postCode ?
        application.postCode : '/'}}</h6>
      <h6 *ngIf="application?.notes && application?.notes !== ''" class="widget-user-desc"><strong
          translate>Note:</strong> {{application?.notes}}</h6>
      <h6 class="widget-user-desc"><strong translate>customer.credits</strong> {{application?.credits ?
        application.credits : '/'}}</h6>
      <h6 class="widget-user-desc"><strong translate>customer.paymentType</strong> {{application?.paymentType ?
        application.paymentType : '/'}}</h6>

      <div style="min-height: 40px; display: flex; align-items: center; padding: 8px; gap: 8px;">
        <ng-container *ngIf="customerId && application?.customerId !== customerId">
          <div class="badge">Subcustomer Client</div>
        </ng-container>
        <ng-container *ngIf="application?.paymentType === 'prepaid' && application.credits && +application.credits < creditsLimit">
          <div class="badge low-credits">Low Credits</div>
        </ng-container>
      </div>
    </div>
  </div>
</div> -->

<div class="application card card-widget widget-user" style="position: relative;">
  <!-- dropdown lives outside of the routerLink anchor -->
  <div class="edit-container" style="position: absolute; top: 8px; right: 8px; z-index: 2;">
    <div class="dropdown">
      <button class="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <i class="fa fa-ellipsis-v"></i>
      </button>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
        <ng-container *ngIf="!router.url.includes('/root/applications')">
          <a class="dropdown-item" style="cursor: pointer;" (click)="onEditClient(application)" translate>global.edit</a>
          <a *ngIf="currentUser.role.name === 'root'" class="dropdown-item" style="cursor: pointer;"
            (click)="onInvoiceConfig(application)" translate>
            Invoice Config
          </a>
          <a *ngIf="currentUser.role.name === 'root'" class="dropdown-item" style="cursor: pointer;"
            (click)="onSSHSetup(application)" translate>
            SSH Key Setup
          </a>
        </ng-container>
        <a *ngIf="['root', 'customer'].includes(currentUser.role.name)" class="dropdown-item" style="cursor: pointer;"
          (click)="onChangeCustomer(application)" translate>
          Change Customer
        </a>
      </div>
    </div>
  </div>

  <!-- this anchor handles navigation -->
  <a class="card-content" [routerLink]="router.url.includes('/root/applications') ? [application?.id] : []"
    [queryParams]="urlParams" [ngClass]="{
      'selected': application?.id === selectedApp?.id ||
                  router.url.includes(application?.id)
    }" style="display: block; text-decoration: none; color: inherit; z-index: 1;">
    <div [ngClass]="{ 'card-dark': router.url.includes('/customer/users') }">
      <div class="widget-user-header" (click)="showUsers(application)">
        <a class="widget-user-username">{{ application?.name }}</a>
        <hr>
        <h6 class="widget-user-desc">
          <strong translate>customer.description</strong>
          {{ application?.description }}
        </h6>
        <h6 *ngIf="router.url.includes('/root/applications')" class="widget-user-desc">
          <strong>Belongs to:</strong> {{ customer }}
        </h6>
        <h6 class="widget-user-desc">
          <strong translate>customer.country</strong>
          {{ application?.country || '/' }}
        </h6>
        <h6 class="widget-user-desc">
          <strong translate>customer.city</strong>
          {{ application?.city || '/' }}
        </h6>
        <h6 class="widget-user-desc">
          <strong translate>customer.address</strong>
          {{ application?.address || '/' }}
        </h6>
        <h6 class="widget-user-desc">
          <strong translate>customer.postCode</strong>
          {{ application?.postCode || '/' }}
        </h6>
        <h6 *ngIf="application?.notes" class="widget-user-desc">
          <strong translate>Note:</strong> {{ application?.notes }}
        </h6>
        <h6 class="widget-user-desc">
          <strong translate>customer.credits</strong>
          {{ application?.credits || '/' }}
        </h6>
        <h6 class="widget-user-desc">
          <strong translate>customer.premiumCredits</strong>
          {{ application?.premiumCredits || 0 }}
        </h6>
        <h6 class="widget-user-desc">
          <strong translate>customer.paymentType</strong>
          {{ application?.paymentType || '/' }}
        </h6>

        <div style="min-height: 40px; display: flex; align-items: center; padding: 8px; gap: 8px;">
          <ng-container *ngIf="customerId && application?.customerId !== customerId">
            <div class="badge">Subcustomer Client</div>
          </ng-container>
          <ng-container *ngIf="
              application?.paymentType === 'prepaid' &&
              application.credits &&
              +application.credits < creditsLimit
            ">
            <div class="badge low-credits">Low Credits</div>
          </ng-container>
        </div>
      </div>
    </div>
  </a>
</div>